<template lang="html">
	<div class="manager-track-report center-panel report">
		<md-content md-theme="white" v-loader-overlay="progress" class="md-elevation-1">
			<sort-table
				v-bind:columns="tableColumns" v-model="deals" @refresh="getDeals" v-bind:per-page="perPage" 
				v-bind:total="dealsAmount" table-id="report" default-order="desc" default-sort="id"
				v-bind:showAddButton="false"
			>
				<template slot="first_freight" slot-scope="scope">
					<span class="no-break-text"> {{(scope.item.first_freight && scope.item.first_freight.traking_number) ? scope.item.first_freight.traking_number : 'Не установлен'}} </span>
				</template>

				<template slot="created_at" slot-scope="scope">
					<span class="no-break-text"> {{(scope.item.created_at && scope.item.created_at) ? moment(scope.item.created_at).format('DD MMM YYYY') : 'Не установлен'}} </span>
				</template>

				<template slot="from_stock" slot-scope="scope">
					<span v-if="scope.item.from_address && scope.item.from_address.address"> {{scope.item.from_address.address}} </span>
					<span v-if="scope.item.from_stock && scope.item.from_stock.name" class="no-break-text"> {{scope.item.from_stock.name}} </span>
					<span v-if="!scope.item.from_address && !scope.item.from_stock" class="no-break-text"> Не указан </span>
				</template>

				<template slot="to_stock" slot-scope="scope">
					<span v-if="scope.item.to_address && scope.item.to_address.address"> {{scope.item.to_address.address}} </span>
					<span v-if="scope.item.to_stock && scope.item.to_stock.name" class="no-break-text"> {{scope.item.to_stock.name}} </span>
					<span v-if="!scope.item.to_address && !scope.item.to_stock" class="no-break-text"> Не указан </span>
				</template>

				<template slot="payer" slot-scope="scope">
					<span v-if="scope.item.payer && scope.item.payer.name"> {{scope.item.payer.name}} </span>
					<span v-else> Не указан </span>
				</template>

				<template slot="executor" slot-scope="scope">
					<span v-if="scope.item.executor && scope.item.executor.name"> {{scope.item.executor.name}} </span>
					<span v-else> Не указан </span>
				</template>

				<template slot="payment_type" slot-scope="scope">
					<span></span>
				</template>

				<template slot="credit" slot-scope="scope">
					<span></span>
				</template>
			</sort-table>
		</md-content>
	</div>
</template>
<script>
	import SortTable from "@/components/SortTable"
	import reportsMenu from './reports-menu';
	export default {
		components: {SortTable, reportsMenu},
		data() {
			return {
				tableColumns: [
					{label: 'ID',             field: 'id',            sortable: true },
					{label: 'Треккод',        field: 'first_freight', sortable: true },
					{label: 'Дата создания',  field: 'created_at',    sortable: true },
					{label: 'П. отпр',        field: 'from_stock',    sortable: false},
					{label: 'П. назн',        field: 'to_stock',      sortable: false},
					{label: 'Плательщик',     field: 'payer',         sortable: false },
					{label: 'Организация',    field: 'executor',      sortable: false },
					{label: '',    			  field: 'actions',      sortable: false },
					//{label: 'Тип оплаты',     field: 'payment_type',  sortable: false },
					//{label: 'Долг',           field: 'credit',        sortable: false } 
				],
				currentPage: 1,
				perPage: 50,
				filter: null,
				docs: {
					bill: 'Счёт',
					invoice: 'Счёт фактура',
					assignment: 'Поручение экспедитору',
					recepit: 'Экспедиторская расписка',
					act: 'Акт выполненных работ',
					stock_note: 'Складская записка',
					route_list: 'Маршрутный лист'
				}
			}
		},
		created() {
			this.$store.dispatch('deals/getStatuses');
			this.$store.commit('setTitle', 'Путевой отчет менеджера');
		},
		watch: {
			'$route.query.filter'(filter) {
				if (filter) this.filter = Object.assign({}, JSON.parse(filter));
				else this.filter = null;
				this.getDeals(this.currentPage, this.perPage, 'id', 'desc');
			}
		},
		computed: {
			/**
			 * Флаг загрузки текущего компонента
			 */
			progress() {
				return this.progressObj['get-deals-list'];
			},
			/**
			 * Объект флагов загрузки
			 */
			progressObj() {
				return this.$store.state.progressObj;
			},
			/**
			 * Список заявок
			 */
			deals() {
				return this.$store.state.deals.deals
			},
			/**
			 * Количество заявок
			 */
			dealsAmount() {
				return this.$store.state.deals.deals_amount
			},
		},
		methods: {
			/**
			 * Получение заявок
			 */
			getDeals(page, count, orderBy, orderType) {
				this.$store.commit('showProgressBar', 'get-deals-list');
				let data = {
					page:       (page)      ? page      : 1, 
					order_by:   (orderBy)   ? orderBy   : 'id', 
					order_type: (orderType) ? orderType : 'desc',
					count:      (count)     ? count     : 50,
					filter:     (this.filter) ? this.filter : null 
				};
				this.$store.dispatch('deals/getDeals', data)
					.finally(() => this.$store.commit('hideProgressBar', 'get-deals-list'));
			},
		}
	}
</script>


// WEBPACK FOOTER //
// PaymentReport.vue?0bcc0653